import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { useLoyalty } from "@jti/ui";
import styles from "./style.module.scss";
export const MembershipLevelDisplay = () => {
    const isLoyaltyActive = useLoyalty();
    const [isLoaded, setLoaded] = useState(false);
    const [tier, setTier] = useState("");
    useEffect(() => {
        const user = getUser();
        if (isLoyaltyActive && user.uuid && user.ciam_token) {
            LoyaltyApi.init()
                .getUserTier(user.uuid, user.ciam_token)
                .then((response) => {
                setTier(response.name);
                setLoaded(true);
            })
                .catch((error) => {
                console.error("Error fetching user tier:", error);
            });
        }
    }, [isLoyaltyActive]);
    if (!isLoaded) {
        return null;
    }
    return (_jsx("span", { className: styles.membershipLevelDisplay, "data-testid": "membershipLevelDisplay", children: tier }));
};
//# sourceMappingURL=MembershipLevelDisplay.js.map